module.exports = __webpack_public_path__ + "img/parceiros_icon.88cdb2c2.svg";